import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// RxJS
import { Subject, takeUntil } from 'rxjs';

// Services
import { AuthService } from '@modules/auth/services/auth.service';
import { UsersService } from '@modules/users/services/users.service';

// Types
import { Account } from '@modules/users/types/account';
import { Team } from '@modules/users/types/user';
import { Theme } from '@modules/settings/types/theme';
import { ThemeService } from '@modules/settings/services/theme.service';

interface MenuItem {
  name: string;
  link: string;
  requiresSuperuser?: boolean;
}

@Component({
    selector: 'app-left-panel',
    templateUrl: './left-panel.component.html',
    styleUrl: './left-panel.component.less',
    standalone: false
})
export class LeftPanelComponent implements OnInit, OnDestroy {

  // Public
  public menuItems: MenuItem[] = [
    {name: 'Project Settings', link: 'project'},
    {name: 'Records/Schedule', link: 'records'},
    {name: 'Users', link: 'users'},
    {name: 'Settings', link: 'settings', requiresSuperuser: true},
  ];
  public selectedMenuItem?: string = 'Records';
  public projectId?: string | null;
  public account?: Account;
  public accountTeam?: Team;
  public theme?: Theme;

  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    private authService: AuthService,
    private usersService: UsersService,
    private themeService: ThemeService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
    // Project id from the route — this component sits inside LayoutComponent, so its
    // ActivatedRoute is the one carrying ':projectId'.
    this.route.paramMap
      .pipe(takeUntil(this.alive))
      .subscribe(params => this.projectId = params.get('projectId'));
    // Get Account
    this.usersService.getAccount()
      .pipe(takeUntil(this.alive))
      .subscribe(account => this.account = account);
    // Get Account Team
    this.usersService.getAccountTeam()
      .pipe(takeUntil(this.alive))
      .subscribe(team => this.accountTeam = team);
    // Theme
    this.theme = this.themeService.theme;
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  selectMenuItem(item: MenuItem): void {
    this.selectedMenuItem = item.name;
    // this.router.navigate([item.link]);
  }

  canShowMenuItem(item: MenuItem): boolean {
    if (item.requiresSuperuser) {
      return this.account?.role === 'admin' && !!this.accountTeam?.permissions?.includes('admin:all');
    }
    return true;
  }

  openUserSettings(): void {
    this.selectedMenuItem = '';
    this.router.navigate(['/', this.projectId, 'account']);
  }

  logout(): void {
    this.authService.logout();
  }

}
